export default __webpack_public_path__ + "static/media/sewa-donate.22943440.png";